import { createBrowserRouter, Navigate } from "react-router";
import { lazy, Suspense } from "react";

import { RootLayout } from "@/routes/root";
import { PageLoader } from "@/components/feedback/PageLoader";

const Dashboard = lazy(() => import("@/routes/dashboard"));
const ReportsLayout = lazy(() => import("@/routes/reports/layout"));
const GuestLedger = lazy(() => import("@/routes/reports/guest-ledger"));
const CityLedger = lazy(() => import("@/routes/reports/city-ledger"));
const VatReport = lazy(() => import("@/routes/reports/vat"));
const ExceptionsIndex = lazy(() => import("@/routes/exceptions/index"));
const ExceptionDetail = lazy(() => import("@/routes/exceptions/detail"));
const SyncIndex = lazy(() => import("@/routes/sync/index"));
const SyncDetail = lazy(() => import("@/routes/sync/detail"));
const AdminLayout = lazy(() => import("@/routes/admin/layout"));
const MappingAdmin = lazy(() => import("@/routes/admin/mapping"));
const CorporateAccountsAdmin = lazy(() => import("@/routes/admin/corporate-accounts"));
const OtaChannelsAdmin = lazy(() => import("@/routes/admin/ota-channels"));
const UsersAdmin = lazy(() => import("@/routes/admin/users"));
const SignIn = lazy(() => import("@/routes/sign-in"));
const NotFound = lazy(() => import("@/routes/not-found"));

function lazyRoute(Element: React.ComponentType) {
  return (
    <Suspense fallback={<PageLoader />}>
      <Element />
    </Suspense>
  );
}

export const router = createBrowserRouter([
  {
    path: "/sign-in",
    element: lazyRoute(SignIn),
  },
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: lazyRoute(Dashboard) },
      {
        path: "reports",
        element: lazyRoute(ReportsLayout),
        children: [
          { index: true, element: <Navigate to="guest-ledger" replace /> },
          { path: "guest-ledger", element: lazyRoute(GuestLedger) },
          { path: "city-ledger", element: lazyRoute(CityLedger) },
          { path: "vat", element: lazyRoute(VatReport) },
        ],
      },
      {
        path: "exceptions",
        children: [
          { index: true, element: lazyRoute(ExceptionsIndex) },
          { path: ":id", element: lazyRoute(ExceptionDetail) },
        ],
      },
      {
        path: "sync",
        children: [
          { index: true, element: lazyRoute(SyncIndex) },
          { path: ":runId", element: lazyRoute(SyncDetail) },
        ],
      },
      {
        path: "admin",
        element: lazyRoute(AdminLayout),
        children: [
          { index: true, element: <Navigate to="mapping" replace /> },
          { path: "mapping", element: lazyRoute(MappingAdmin) },
          { path: "corporate-accounts", element: lazyRoute(CorporateAccountsAdmin) },
          { path: "ota-channels", element: lazyRoute(OtaChannelsAdmin) },
          { path: "users", element: lazyRoute(UsersAdmin) },
        ],
      },
      { path: "*", element: lazyRoute(NotFound) },
    ],
  },
]);
